var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 171.84 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f3ba2f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M85.92,0L0,49.6v99.22l85.92,49.6,85.92-49.6V49.6L85.92,0ZM85.92,184.34L12.19,141.78v-38.14l48.74,28.48c-.26,1.21-.42,2.46-.42,3.75,0,9.69,7.89,17.58,17.58,17.58s17.58-7.89,17.58-17.58-7.89-17.58-17.58-17.58c-3.96,0-7.58,1.36-10.52,3.58L12.19,89.51v-32.87L85.92,14.08l73.73,42.56v41.6l-49.26-28.79c.26-1.21.42-2.46.42-3.75,0-9.69-7.89-17.58-17.58-17.58s-17.58,7.88-17.58,17.58,7.89,17.58,17.58,17.58c3.96,0,7.58-1.37,10.52-3.58l55.9,32.67v29.41l-73.73,42.56ZM70.67,135.87c0-4.09,3.33-7.41,7.42-7.41s7.42,3.33,7.42,7.41-3.33,7.42-7.42,7.42-7.42-3.33-7.42-7.42ZM100.65,65.7c0,4.09-3.33,7.42-7.42,7.42s-7.42-3.33-7.42-7.42,3.33-7.41,7.42-7.41,7.42,3.33,7.42,7.41Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpd);
export default __webpack_public_path__ + "static/media/spd.287e5941df61587749a779c03250af75.svg";
export { ForwardRef as ReactComponent };